"use client";

export default function SuccessModal({ show, onClose }) {
    if (!show) return null;

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal">

                <div className="success-icon">
                    ✔
                </div>

                <h2 className="title">Thank You!</h2>

                <p className="subtitle">
                    Your account details have been submitted successfully.
                </p>

                <p className="subtitle">
                    You can now return to your dashboard and continue exploring.
                </p>

                <div className="actions d-flex justify-content-center">
                    <button className="primary">
                        Go To Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
}
